<template>
  <Page
    has-actions
    :loading="loading"
    :subtitle="`${total} ${$tc('result', total <= 1 ? 1 : 2)}`"
  >
    <Card
      v-if="$can('read', 'international.countries.vat')"
      content-class="c-table"
    >
      <b-table
        :data="items"
        :total="items.length"
        :per-page="pagination.perPage"
        :current-page="pagination.page"
        paginated
        hoverable
      >
        <b-table-column    
          field="type.id"
          :label="this.$i18n.tc('type', 1)"
          width="80"
          header-class="sticky-header"
          sortable
          searchable
        >
          <template #searchable="props">
            <b-select-validation
              v-model="props.filters['type.id']"
              rounded
              size="is-small"
              hide-details
            >
              <template>
                <option
                  v-for="opt in filters.tax_types"
                  :key="opt.id"
                  :value="opt.id"
                >
                  {{ opt.label }}
                </option>
              </template>
            </b-select-validation>
          </template> 
          <template v-slot="props">
            <span>
              {{ props.row.type ? props.row.type.label : "-" }}
            </span>
          </template>
        </b-table-column>
        <b-table-column
          field="rate"
          :label="this.$i18n.t('rate')"
          width="60"
          header-class="sticky-header"
          sortable
          searchable
        >
        <template #searchable="props">
            <b-input
              v-model="props.filters.rate"
              :placeholder="placeholders.number.decimal_2"
              rounded
              size="is-small"
              hide-details
            />
          </template> 
          <template v-slot="props">
            <span>
              {{ props.row.rate ? props.row.rate : "-" }}
            </span>
          </template>
        </b-table-column>
        <b-table-column
          field="countries"
          :label="this.$i18n.tc('country', 2)"
          width="400"
          header-class="sticky-header"
          sortable
        >
        <!-- <template #searchable="props">
            <b-input
              v-model="props.filters.rate"
              :placeholder="placeholders.number.decimal_2"
              rounded
              size="is-small"
              hide-details
            />
          </template>  -->
          <template v-slot="props">
            <div class="is-flex is-flex-wrap-wrap">
              <div v-for="country, index in props.row.countries" :key="country.iso">
                <router-link
                  v-if="
                    $can('read', 'international.countries.vat')
                  "
                  :to="`/international/countries/${country.iso}`"
                  target="_blank"
                >
                  {{ country ? country.label : "-" }}
                </router-link>
                <span v-else >{{ country ? country.label : "-" }}</span>
                <span v-if="index < props.row.countries.length - 1" class="mr-1">,</span>
              </div>
            </div>
          </template>
        </b-table-column>
        <b-table-column
          field="active"
          :label="$tc('active', 1)"
          header-class="sticky-header"
          sortable
          searchable
          centered
          width="60"
        >   
          <template #searchable="props">
            <b-select-validation
              v-model="props.filters.active"
              rounded
              size="is-small"
              hide-details
            >
              <template>
                <option :value="true">
                  {{ $t("yes") }}
                </option>
                <option :value="false">
                  {{ $t("no") }}
                </option>
              </template>
            </b-select-validation>
          </template> 
          <template v-slot="props">   
            <b-icon
              :icon=" props.row.active ? 'check' : 'close'"
              :type="props.row.active ? 'is-success' : 'is-danger'"
              size="is-small"
            />
          </template>
        </b-table-column>
      </b-table>
      <Pagination
        :per-page="pagination.perPage"
        :per-pages="rowsPerPage"
        :total="items.length"
        :current-page="pagination.page"
        @update-per-page="val => (pagination.perPage = val)"
        @update-current-page="val => (pagination.page = val)"
      /> 
    </Card>
  </Page>
</template>

<script>
export default { 
  data() {
    return {
      rowsPerPage: [50, 100, 200],
      pagination: { perPage: 50, page: 1 },
      loading: false,
      total:0,
	    items: [],
      filters: [],
      
    };
  },
  created() {
    this.updateTitle(this.$i18n.tc("vat", 2));
	  this.getItems();
  },  
  methods: {
	  getItems() {
      if (!this.$can("read", "international.countries.vat")) return;
      this.loading = true;
      this.$axios
        .get(`/ecommerce/taxes`)
          .then(res  => {
            this.items = res.data.list;
            this.filters = res.data.filters;
            this.total = res.data.pagination.total;
          })
        .catch(e => this.$root.clientError(e))
        .finally(() => (this.loading = false));
    },
  }
};
</script>